import { render, staticRenderFns } from "./CardFull.vue?vue&type=template&id=04ed66af&scoped=true&"
import script from "./CardFull.vue?vue&type=script&lang=js&"
export * from "./CardFull.vue?vue&type=script&lang=js&"
import style0 from "./CardFull.vue?vue&type=style&index=0&id=04ed66af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed66af",
  null
  
)

export default component.exports